import "./dashboard.css";
import {CustomLink} from "./navigation/navbar";
import WeexWeekProgram from "./calender/WeexWeekProgram";
import {weexLocalizer} from "../App";
import WeexWeek from "./calender/WeexWeek";
import {useContext, useEffect, useState} from "react";
import {APIContext} from "./Globals.tsx";
import {renderNews} from "./News";
import DashCalendar from "./DashCalendar.tsx";

const dateFromObjectId = function (objectId){
    return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
};

export default function Dashboard(){
    const [users, setUsers] = useState([]);
    const [news, setNews] = useState([]);
    const {getUsers, fetchNews} = useContext(APIContext);

    useEffect(() => {
        getUsers().then((ans) => {
            setUsers([ans?.persons.length, ans?.persons.filter((person) =>
                (new Date - dateFromObjectId(person.id)) / (1000 * 3600 * 24) < 31
            ).length, ans]);
        });
        fetchNews().then((res) => {
            setNews(res?.news ?? []);
        });
    }, []);

    return (
        <div id={"dashboardgrid"}>
            <CustomLink to="/news">
                <div className={"dashboardtile"}>
                    <h3>Neuigkeiten</h3>
                    {renderNews(news[0] ?? [], null, null, null, {
                        style: {
                            width: "100%",
                            maxHeight: "180px",
                            overflowY: "clip",
                            paddingTop: 0
                        }
                    })}
                </div>
            </CustomLink>
            <CustomLink to="/planning">
                <div className={"dashboardtile none-mobile-tile"}>
                    <h3>Programmplanung</h3>
                    <WeexWeekProgram date={new Date()} localizer={weexLocalizer} preview={true}/>
                </div>
            </CustomLink>
            <div className={"dashboardtile"} id={"bigtile"}>
                <DashCalendar users={users}/>
            </div>
            <CustomLink to="/users">
                <div className={"dashboardtile"}>
                    <h3>Mitglieder</h3>
                    <div className={"centerAll"} style={{
                        display: "flex",
                        justifyContent: "space-around",
                        textAlign: "center",
                        height: "calc(100% - 60px)"
                    }}>
                        <div>
                            <h4 style={{
                                color: "var(--accent)",
                                fontSize: 40,
                                margin: 0
                            }}>{users[0]}</h4>
                            <div>Mitglieder</div>
                        </div>
                        <div>
                            <h4 style={{
                                color: "var(--green)",
                                fontSize: 40,
                                margin: 0
                            }}>+{users[1]}</h4>
                            <div>Neue <br/> (letzten 4 Wochen)</div>
                        </div>
                    </div>
                </div>
            </CustomLink>
            <CustomLink to="/schedule">
                <div className={"dashboardtile"}>
                    <h3>Kursplanung</h3>
                    <WeexWeek date={new Date()} localizer={weexLocalizer} preview={true}/>
                </div>
            </CustomLink>
          <CustomLink to="/boxtv">
            <div className={"dashboardtile none-mobile-tile"}>
              <h3>Box TV</h3>
              <div className={"centerAll"} style={{height: "calc(100% - 60px)", maxHeight: "180px"}}>
                {/*<img style={{maxHeight: "100%", opacity: "100%"}} src={settingIcon} alt={"settings"}/>*/}
              </div>
            </div>
          </CustomLink>
          <CustomLink to="/products">
            <div className={"dashboardtile none-mobile-tile"}>
              <h3>Produkte</h3>
            </div>
          </CustomLink>
          <CustomLink to="/settings">
            <div className={"dashboardtile"}>
              <h3>Einstellungen</h3>
              <div className={"centerAll"} style={{height: "calc(100% - 60px)", maxHeight: "180px"}}>
                        {/*<img style={{maxHeight: "100%", opacity: "100%"}} src={settingIcon} alt={"settings"}/>*/}
                    </div>
                </div>
            </CustomLink>
            <div className={"dashboardtile none-mobile-tile"} style={{opacity: 0.5, pointerEvents: "none"}}>
                <h3>Statistiken</h3>
            </div>
        </div>
    );
}
